export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/invitations', { params: data.filters })
  },
  postOne (data = {}) {
    return axios.post('/invitation', data.body, { params: data.filters })
  },
  getOne (data = {}) {
    return axios.get('/invitation/' + data.id, { params: data.filters })
  },
  patchOne (data = {}) {
    return axios.patch('/invitation/' + data.id, data.body, { params: data.filters })
  },
  deleteOne (data = {}) {
    return axios.delete('/invitation/' + data.id, { params: data.filters })
  }
})
